module.exports = __webpack_public_path__ + "img/cn-stu-2.b1647463.png";